@if (useSheet()) {
  <app-bottom-dialog [(visible)]="visible">
    <div class="content">
      @let title = sheetTitle();
      @if (title) {
        <div class="text-18 fw-600 color-gray-900 mb-16">{{ title }}</div>
      }
      <div class="list">
        <div class="scroll-wrapper scrollbar-gray">
          @for (group of sheetGroups(); track $index) {
            <div class="group">
              @if (group.label) {
                <div class="group-label text-10 fw-500">{{ group.label }}</div>
              }
              @for (item of group.options; track $index) {
                <div
                  class="option-item p-10-16 flex align-items-center gap-8"
                  [class]="item.option.styleClass"
                  [class.selected]="item.selected"
                  [class.disabled]="item.option.disabled"
                  (click)="selectSheetOption($event, item.option)"
                >
                  @if (item.option.icon) {
                    <i [class]="item.option.icon"></i>
                  }
                  <div class="text-14">{{ item.option.label }}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </app-bottom-dialog>
} @else if (hasNestedOptions()) {
  <app-tiered-menu
    #menu
    [appendTo]="appendTo()"
    [options]="allOptions()"
    [panelWidth]="'mw-200'"
    [startText]="startText()"
  ></app-tiered-menu>
} @else {
  <app-menu
    #menu
    [appendTo]="appendTo()"
    [options]="allOptions()"
    [startText]="startText()"
  ></app-menu>
}
